/**
 * Admin-specific hooks
 *
 * These hooks are designed for admin users and include data that should not
 * be visible to public users (cancelled matches, inactive teams, etc.)
 *
 * Keep these separate from public hooks to:
 * - Prevent accidental exposure of admin-only data
 * - Maintain clear separation of concerns
 * - Optimize query caching (separate query keys)
 */

export { useOrganizerPlayers } from "./useOrganizerPlayers";
export { useOrganizerTournaments } from "./useOrganizerTournaments";
